// extracted by mini-css-extract-plugin
export default {"form":"custom-cause-input_form__HxAsQ","label":"custom-cause-input_label__MSm1h","input":"custom-cause-input_input__TDEfy","twoColumns":"custom-cause-input_twoColumns__8A0ZO"};